module.exports = __webpack_public_path__ + "img/img_asset_waterwheel.0f128c64.svg";